import React from 'react';
import { Box, Typography } from '@mui/material';
import AnimeMascot from './AnimeMascot';
import { FloatingBubble, ChatBubble, Star, GlowOrb } from './Decorations';

const LoginScene: React.FC = () => (
  <Box
    sx={{
      flex: 1,
      display: { xs: 'none', md: 'flex' },
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      p: 6,
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    {/* Floating orbs */}
    <FloatingBubble size={8} top="12%" left="20%" color="rgba(124,77,255,0.4)" delay={0} duration={6} animation="float-slow" />
    <FloatingBubble size={5} top="25%" left="75%" color="rgba(255,64,129,0.4)" delay={1} duration={5} animation="float-medium" />
    <FloatingBubble size={12} top="70%" left="15%" color="rgba(124,77,255,0.2)" delay={0.5} duration={7} animation="float-slow" />
    <FloatingBubble size={6} top="80%" left="80%" color="rgba(0,230,118,0.3)" delay={2} duration={5} animation="float-fast" />
    <FloatingBubble size={10} top="40%" left="85%" color="rgba(124,77,255,0.15)" delay={1.5} duration={8} animation="drift-right" />
    <FloatingBubble size={4} top="55%" left="10%" color="rgba(255,64,129,0.3)" delay={0.8} duration={4} animation="twinkle" />

    {/* Stars */}
    <Star top="8%" left="35%" size={16} delay={0} />
    <Star top="18%" left="65%" size={12} delay={1.5} />
    <Star top="75%" left="70%" size={14} delay={0.8} />
    <Star top="60%" left="25%" size={10} delay={2.2} />

    {/* Chat bubbles */}
    <ChatBubble top="15%" left="8%" text="Hello! 👋" color="rgba(124,77,255,0.85)" delay={0} />
    <ChatBubble top="30%" left="62%" text="How are you?" color="rgba(255,64,129,0.75)" delay={1.2} flip />
    <ChatBubble top="72%" left="55%" text="Let's chat! 💬" color="rgba(124,77,255,0.7)" delay={0.6} />
    <ChatBubble top="58%" left="5%" text="GG! 🎮" color="rgba(0,230,118,0.5)" delay={2} flip />

    {/* Ambient glow */}
    <GlowOrb size={300} top="5%" left="5%" color="rgba(124,77,255,0.15)" />
    <GlowOrb size={200} bottom="15%" right="10%" color="rgba(255,64,129,0.1)" blur={30} />

    {/* Mascot + branding */}
    <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
      <Box sx={{ mb: 2, animation: 'float-medium 4s ease-in-out infinite' }}>
        <AnimeMascot />
      </Box>

      <Typography
        variant="h3"
        sx={{
          fontWeight: 800,
          mb: 1,
          background: 'linear-gradient(135deg, #e8e8f0 30%, #7c4dff 70%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        ChatApp
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: '#8888a8', maxWidth: 340, mx: 'auto' }}
      >
        Connect instantly with friends across the world
      </Typography>
    </Box>
  </Box>
);

export default LoginScene;
